import PropTypes from 'prop-types';
export const calculatorPropTypes = {
  /**
   * Heading
   */
  heading: PropTypes.string,
  /**
   * Description
   */
  description: PropTypes.string,
  /**
   * Badge content
   */
  badge: PropTypes.string,
  /**
   * Children
   */
  children: PropTypes.node
};